'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var iconSwitcher = function () {
  function iconSwitcher(type, props) {
    switch (type) {
      case 'positive':
        return _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
          icon: _freeSolidSvgIcons.faCheckCircle
        }, props));
      case 'cautionary':
        return _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
          icon: _freeSolidSvgIcons.faExclamationCircle
        }, props));
      case 'urgent':
        return _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
          icon: _freeSolidSvgIcons.faExclamationCircle
        }, props));
      case 'information':
        return _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
          icon: _freeSolidSvgIcons.faInfoCircle
        }, props));
      default:
        return _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
          icon: _freeSolidSvgIcons.faInfoCircle
        }, props));
    }
  }
  return iconSwitcher;
}();
var ToastContentBase = function (_React$Component) {
  _inherits(ToastContentBase, _React$Component);
  function ToastContentBase(props) {
    _classCallCheck(this, ToastContentBase);
    var _this = _possibleConstructorReturn(this, (ToastContentBase.__proto__ || Object.getPrototypeOf(ToastContentBase)).call(this, props));
    _this.renderMessage.bind(_this);
    return _this;
  }
  _createClass(ToastContentBase, [{
    key: 'renderMessage',
    value: function () {
      function renderMessage() {
        var _this2 = this;
        return this.props.message.map(function (msg, index) {
          return msg.type === 'link' ? _react2['default'].createElement('span', {
            name: 'link',
            type: msg.type,
            onClick: function () {
              function onClick() {
                msg.clickToClose && _this2.props.closeToast();
                msg.onClick && msg.onClick();
              }
              return onClick;
            }(),
            key: index
          }, ' ', msg.text, ' ') : _react2['default'].createElement('span', {
            type: msg.type,
            key: index
          }, ' ', msg.text, ' ');
        });
      }
      return renderMessage;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;
        return _react2['default'].createElement('div', {
          type: this.props.type,
          testid: this.props.testid,
          className: this.props.className
        }, _react2['default'].createElement('div', {
          name: 'header',
          type: this.props.type
        }), iconSwitcher(this.props.type, {
          name: 'headerIcon'
        }), _react2['default'].createElement('div', {
          name: 'messageWrapper'
        }, ' ', this.renderMessage(), ' '), this.props.closeIcon && _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faTimes,
          name: 'closeIcon',
          onClick: function () {
            function onClick() {
              _this3.props.closeToast && _this3.props.closeToast();
              _this3.props.onCloseClick && _this3.props.onCloseClick();
            }
            return onClick;
          }()
        }));
      }
      return render;
    }()
  }]);
  return ToastContentBase;
}(_react2['default'].Component);
var message = {
  /**
   * text or react element
   */
  text: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
  /**
   * only link type supported for now
   */
  type: _propTypes2['default'].oneOf(['link']),
  /**
   * for links onClick callback function
   */
  onClick: _propTypes2['default'].func,
  /**
   * for links if toast should be closed when clicked
   */
  clickToClose: _propTypes2['default'].bool
};
ToastContentBase.propTypes = {
  /**
   * shape the message should adhere to
   */
  message: _propTypes2['default'].arrayOf(_propTypes2['default'].shape(message)),
  /**
   * className from styling
   */
  className: _propTypes2['default'].string,
  /**
   * if closeIcon is supposed to be present
   */
  closeIcon: _propTypes2['default'].bool,
  /**
   * on clicking closeIcon
   */
  onCloseClick: _propTypes2['default'].func,
  /**
   * injected through renderprops from Toast (input is not required)
   */
  closeToast: _propTypes2['default'].func,
  /**
   * test specific id
   */
  testid: _propTypes2['default'].string,
  /**
   * type of message effects styling
   */
  type: _propTypes2['default'].oneOf(['positive', 'cautionary', 'urgent', 'information'])
};
ToastContentBase.defaultProps = {
  message: [],
  closeIcon: false,
  type: 'information'
};
ToastContentBase.displayName = 'ToastContent';
exports['default'] = ToastContentBase;